import { createContext } from 'react';
import initialMainContactsState from './initialMainContactsState';

const MainContactsContext = createContext(initialMainContactsState);

export default MainContactsContext;
